import merge from 'lodash/merge';
import $api from '../api/index';

const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  find: state => id => state.byId[id],
  findOrderItems: () => order => [
    // Yes, products first... this is NOT a mistake lol
    ...order.orderProducts,
    ...order.orderDeals,
    ...order.orderPackages
  ],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addOrders: ({ commit }, orders) => {
    // New object for us to fix placement of order items into
    orders.forEach(order => {
      const fixedOrder = {
        ...order,
        orderDeals: order.deals?.reduce(
          (acc, deal) => [
            ...acc,
            ...(deal?.order_deals.map(od => ({
              ...deal,
              ...od,
              deal_id: deal.id,
              type: 'deal'
            })) || [])
          ],
          []
        ),
        orderPackages: order.packages?.reduce(
          (acc, pkg) => [
            ...acc,
            ...(pkg?.order_packages.map(op => ({
              ...pkg,
              ...op,
              package_id: pkg.id,
              type: 'package'
            })) || [])
          ],
          []
        ),
        orderProducts: order.products?.reduce(
          (acc, product) => [
            ...acc,
            ...(product?.order_products.map(op => ({
              ...product,
              ...op,
              product_id: product.id,
              type: 'product'
            })) || [])
          ],
          []
        )
      };

      commit('add', fixedOrder);
    });
  },
  getOrderHistory: async ({ dispatch }, payload) => {
    const res = await $api.orders.getOrderHistory(payload);
    const {
      data: { data: orders }
    } = res;
    if (res.status === 200) dispatch('addOrders', orders);

    return res;
  },

  updateOrderProduct: async ({ commit }, orderProduct) => {
    commit('updateOrderProduct', orderProduct);
  }
};

const mutations = {
  add: (state, order) => {
    if (!state.allIds.includes(order.id)) {
      state.byId[order.id] = order;
      state.allIds.push(order.id);
    } else {
      const merged = merge(state.byId[order.id], order);
      state.byId[order.id] = merged;
    }

    const sorted = state.allIds.sort(
      (a, b) => state.byId[b].id - state.byId[a].id
    );
    state.allIds = sorted;
  },
  updateOrderProduct: (state, orderProduct) => {
    const order = state.byId[orderProduct.order_id];
    const index = order.orderProducts.findIndex(
      op => op.id === orderProduct.id
    );
    const merged = merge(order.orderProducts[index], orderProduct);
    order.orderProducts[index] = merged;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
